import { createVNode as l, mergeProps as a } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/InfoCircleFilledStandard.js";
import n from "../components/PfIcon.js";
const r = (e, t) => {
  const o = {
    ...e,
    ...t.attrs
  };
  return l(n, a(o, {
    icon: i
  }), null);
};
r.displayName = "InfoCircleFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
